// @flow

import type { PropsSchema, BasicProps } from '../../type'
import * as React from 'react'
import { onClickEvent } from '../hoc'
import computeData from '../hoc/computeData'

type Props = BasicProps & {
  style: { [string]: string },
  value: string,
  onClick: () => void,
  config: any
};

let countUpPromise
function initCountup () {
  if (countUpPromise) {
    return countUpPromise
  }
  return (countUpPromise = Promise.all([import('countup')]).then(
    ([Countup]) => {
      return Countup
    }
  ))
}

@computeData({ includeData: true })
@onClickEvent
export default class Countup extends React.PureComponent<Props> {
  constructor (props: Props) {
    super(props)
    initCountup()
  }

  static schema: PropsSchema = [
    {
      title: '配置',
      key: 'config',
      type: 'code'
    },
    'separator',
    {
      type: 'style',
      group: 'text'
    },
    'separator',
    {
      type: 'event',
      title: '完成',
      event: 'finish'
    }
  ];

  refCb = (target: any) => {
    countUpPromise.then(Countup => {
      this.startAnimation(Countup, target)
    })
  };

  startAnimation = (Countup: any, target: any) => {
    if (!Countup || !target) return
    const { jsEnv } = this.props
    let { config } = this.props
    config = jsEnv.runCode(config)
    const { startVal, endVal, decimals, duration, options } = config || {}
    var countupInstance = new Countup(
      target,
      startVal,
      endVal,
      decimals,
      duration,
      options
    )
    countupInstance.start(this.complete)
  };

  complete = () => {
    let { callActions } = this.props
    callActions('finish')
  };

  render () {
    const { visible } = this.props
    if (!visible) {
      return null
    }
    const { id, style, onClick } = this.props
    return <span id={id} style={style} onClick={onClick} ref={this.refCb} />
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/basic/CountUp.js